import { render, staticRenderFns } from "./MtSaleOrderDetail.vue?vue&type=template&id=9f351de8&scoped=true&"
import script from "./MtSaleOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MtSaleOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./MtSaleOrderDetail.vue?vue&type=style&index=0&id=9f351de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f351de8",
  null
  
)

export default component.exports